export function retryPromise(importPromise: Promise<any>, retries: number = 3): Promise<any> {
    return importPromise.catch(error => {
        if (retries > 0) {
            return new Promise(resolve => setTimeout(resolve, 1000)) // Wait 1 second before retrying
                .then(() => retryPromise(importPromise, retries - 1));
        } else {
            throw error;
        }
    });
}